// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"6afd9e7d","362":"6afd9e7d"}[chunkId] + ".chunk.css";
};